var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("small", { staticStyle: { float: "right" } }, [
      _vm._v(
        _vm._s(
          "created_at" in _vm.data ? _vm.elapsedTime(_vm.data.created_at) : ""
        )
      )
    ]),
    _vm._v(" "),
    "image_url" in _vm.data
      ? _c("div", { staticClass: "text-center" }, [
          _vm.data.image_url
            ? _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: _vm.data.image_url }
              })
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "text-lg font-bold mb-3" }, [
      _vm._v(
        "\n    " + _vm._s("title" in _vm.data ? _vm.data.title : "") + "\n  "
      )
    ]),
    _vm._v(" "),
    _c("div", [_vm._v(_vm._s("body" in _vm.data ? _vm.data.body : ""))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }